import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RootedHome from "./pages/RootedHome";
import AdminLeads from "./pages/AdminLeads";
import WateringSchedule from "./pages/WateringSchedule";
import LeaveReview from "./pages/LeaveReview";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminGalleryUpload from "./pages/AdminGalleryUpload";
import AnalyticsTracker from "./components/AnalyticsTracker";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<RootedHome />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/gallery-upload" element={<AdminGalleryUpload />} />
          <Route path="/watering-schedule" element={<WateringSchedule />} />
          <Route path="/leave-review" element={<LeaveReview />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
